export const formatCurrency = (num) =>
  num?.toLocaleString(undefined, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const getId = (obj) =>
  obj?.id || obj?._id || (typeof obj === "string" ? obj : undefined);

export const getMainImage = (images) => {
  try {
    return (
      handleImage(images?.find((e) => e?.isMain)?.image) ||
      handleImage(images?.[0]?.image) ||
      ""
    );
  } catch (error) {
    // console.log(error);
    return handleImage(images?.[0]?.image);
  }
};

export const handleImage = (image) => {
  if (image) {
    if (!image.includes("http"))
      // eslint-disable-next-line no-undef
      image = `${process.env.NEXT_PUBLIC_MAIN_URL}/${image}`;
    return image;
  }
  // eslint-disable-next-line no-undef
  return image || process.env.NEXT_PUBLIC_MAIN_URL;
};

export const handleSearchParamsChange = (search, params = {}) => {
  const url = new URLSearchParams(search);
  search = { ...url, ...params };
  Object.entries(search).map(([key, value]) => {
    return url.set(key, value);
  });
  return "?" + url;
};

export const handleTextInputKeyPressNumOnly = (e) => {
  // Allow only numeric characters (0-9) and specific keys like Backspace, Delete, and Arrow keys
  const isValidInput = /^[0-9\b]+$/.test(e.key);
  if (!isValidInput) {
    e.preventDefault();
  }
};

export const getDicountPercentage = (disc, price) =>
  `${disc}`?.length > 0
    ? Math.round(
        (1 - (parseFloat(disc || "1") || 1) / (parseFloat(price || "1") || 1)) *
          100
      )
    : 0;

export const getPopupLocationCenter = (w = 600, h = 400) => {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;

  return `
  scrollbars=yes,
  width=${w / systemZoom}, 
  height=${h / systemZoom}, 
  top=${top}, 
  left=${left}
  `;
};
